<template>
  <div class="color-picker">
    <div
      class="color-picker-toggle"
      :class="{ 'color-picker-toggle--active': active }"
      :style="{ backgroundColor: value, color: getContrast(value) }"
      @click="active = !active"
    >
      <div class="mck2">2</div>
      <!-- <div class="arrow-down"></div> -->
    </div>
    <div v-if="active" class="color-picker-dropdown">
      <span
        class="color"
        v-for="(c, i) in colors"
        :key="`color-${i}`"
        :style="`background-color: ${c}`"
        @click="select(c)"
      >
        <div
          class="span mck2 check"
          v-if="c === value"
          :style="{ color: getContrast(c) }"
        >
          f
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import contrast from "../mixins/contrast";
export default {
  mixins: [contrast],
  props: ["value"],
  data() {
    return {
      active: false,
      colors: [
        "#ffffff",
        "#fafafa",
        "#f5f5f5",
        "#e8e8e8",
        "#d9d9d9",
        "#747474",
        "#555555",
        "#363636",
        "#171717",
        "#0C0C0C",
        "#fff1f0",
        "#ffccc7",
        "#ffa39e",
        "#ff7875",
        "#ff4d4f",
        "#f5222d",
        "#cf1322",
        "#a8071a",
        "#820014",
        "#5c0011",
        "#fff2e8",
        "#ffd8bf",
        "#ffbb96",
        "#ff9c6e",
        "#ff7a45",
        "#fa541c",
        "#d4380d",
        "#ad2102",
        "#871400",
        "#610b00",
        "#fff7e6",
        "#ffe7ba",
        "#ffd591",
        "#ffc069",
        "#ffa940",
        "#fa8c16",
        "#d46b08",
        "#ad4e00",
        "#873800",
        "#612500",
        "#fffbe6",
        "#fff1b8",
        "#ffe58f",
        "#ffd666",
        "#ffc53d",
        "#faad14",
        "#d48806",
        "#ad6800",
        "#874d00",
        "#613400",
        "#feffe6",
        "#ffffb8",
        "#fffb8f",
        "#fff566",
        "#ffec3d",
        "#fadb14",
        "#d4b106",
        "#ad8b00",
        "#876800",
        "#614700",
        "#fcffe6",
        "#f4ffb8",
        "#eaff8f",
        "#d3f261",
        "#bae637",
        "#a0d911",
        "#7cb305",
        "#5b8c00",
        "#3f6600",
        "#254000",
        "#f6ffed",
        "#d9f7be",
        "#b7eb8f",
        "#95de64",
        "#73d13d",
        "#52c41a",
        "#389e0d",
        "#237804",
        "#135200",
        "#092b00",
        "#e6fffb",
        "#b5f5ec",
        "#87e8de",
        "#5cdbd3",
        "#36cfc9",
        "#13c2c2",
        "#08979c",
        "#006d75",
        "#00474f",
        "#002329",
        "#e6f7ff",
        "#bae7ff",
        "#91d5ff",
        "#69c0ff",
        "#40a9ff",
        "#1890ff",
        "#096dd9",
        "#0050b3",
        "#003a8c",
        "#002766",
        "#f0f5ff",
        "#d6e4ff",
        "#adc6ff",
        "#85a5ff",
        "#597ef7",
        "#2f54eb",
        "#1d39c4",
        "#10239e",
        "#061178",
        "#030852",
        "#f9f0ff",
        "#efdbff",
        "#d3adf7",
        "#b37feb",
        "#9254de",
        "#722ed1",
        "#531dab",
        "#391085",
        "#22075e",
        "#120338",
        "#fff0f6",
        "#ffd6e7",
        "#ffadd2",
        "#ff85c0",
        "#f759ab",
        "#eb2f96",
        "#c41d7f",
        "#9e1068",
        "#780650",
        "#520339",
      ],
    };
  },
  methods: {
    select(c) {
      this.$emit("input", this.value === c ? null : c);
      this.$emit("change");
      this.active = false;
    },
    handleClick(e) {
      if (this.active) {
        if (
          !e.target.classList.contains("color-picker-dropdown") &&
          !e.target.classList.contains("color") &&
          !e.target.classList.contains("check")
        ) {
          this.active = false;
        }
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.handleClick);
  },
  destroyed() {
    document.removeEventListener("mousedown", this.handleClick);
  },
};
</script>

<style scoped>
.color-picker {
  /* position: relative; */
}
.color-picker-toggle {
  align-items: center;
  cursor: pointer;
  background-color: #9b9b9b;
  border-radius: 34px;
  color: #fff;
  display: flex;
  font-size: 16px;
  line-height: 16px;
  justify-content: space-around;
  height: 20px;
  margin-right: 10px;
  width: 44px;
}
.color-picker-toggle--active {
  /* border-bottom-left-radius: 0; */
  /* border-bottom-right-radius: 0; */
}
.color-picker-toggle:hover {
  opacity: 0.8;
}
.arrow-down {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid #fff;
  height: 0;
  width: 0;
}
.color-picker-dropdown {
  background-color: #9b9b9b;
  border-radius: 4px;
  display: flex;
  flex-flow: column wrap;
  height: 194px;
  left: 50%;
  padding: 7px;
  padding-right: 2px;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1;
  width: 424px;
}
.color {
  align-items: center;
  border: 1px solid #fff;
  border-bottom: 0;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  height: 18px;
  justify-content: center;
  margin-right: 5px;
  width: 26px;
}
.color:hover {
  opacity: 0.8;
}
.color:nth-child(10n) {
  border-bottom: 1px solid #fff;
}
</style>